export default __webpack_public_path__ + "static/media/coin.3ccf5acd.png";